import React from "react"
import {useQuery} from "@apollo/client"
import providerListQuery from "graphql/Storage/Provider/query/providerList"
import {ProviderEdit} from "../Edit/ProviderEdit"
import {Link} from "react-router-dom"
import {URL_BACKOFFICE_STORAGE_PROVIDER_ADD} from "static/constant/url"
import {BackofficePage, BackofficePanel, BackofficeEmptyState} from "components/backoffice/Layout/BackofficePage"

import "./style.scss"

export const ProviderList = () => {

  const {data, loading} = useQuery(providerListQuery)
  const providerList = data?.providerList || []

  return <BackofficePage
    className="provider-list-container"
    eyebrow="Infrastructure"
    title="Providers de stockage"
    description="Configurez les espaces source et média utilisés par Zipflix."
    icon="fa-server"
    actions={<Link className="bo-primary-action" to={URL_BACKOFFICE_STORAGE_PROVIDER_ADD}><span className="fas fa-plus"></span>Nouveau provider</Link>}
  >
    <BackofficePanel title="Espaces configurés" description={`${providerList.length} provider${providerList.length > 1 ? "s" : ""}`} icon="fa-hdd">
      <div className="provider-stack">
        {providerList.map((provider: any) => <ProviderEdit key={`provider_${provider?.id}`} id={provider?.id} />)}
      </div>
      {!loading && !providerList.length && <BackofficeEmptyState title="Aucun provider" description="Ajoutez un espace Google Drive ou S3 pour commencer." icon="fa-database" />}
    </BackofficePanel>
  </BackofficePage>
}
